export const ZENDESK_KEY = process.env.GATSBY_ZENDESK_KEY

export const ZendeskStatus = {
  Initial: "initial",
  Loading: "loading",
  Ready: "ready",
}

export const SuggestionsMap = {
  members: ["administration"],
  "settings/builds": ["Builds"],
  cmsPreview: ["Preview"],
  "settings/hosting": ["Gatsby Hosting"],
  "settings/data-sources": ["CMS"],
  builds: ["Builds"],
}
